<template>
<section class="block">

    <div>
      <div class="field">
        <div class="control">
          <!-- <p>{{myimage}}</p> -->
          <a :href="'/images/' + type + myimage" target="_blank" title="Open image in another tab"><img :src="'/images/' + type + myimage" name="myimage" v-model="myimage" v-bind:class="{'is-danger': errors.has('myimage')}" /></a>
        </div>
        <p class="help is-danger" v-show="errors.has('myimage')">
          {{ errors.first('myimage') }}
        </p>

        <div class="file has-name">
          <label class="file-label">
            <input class="file-input" type="file" name="resume" @change="onFileChanged">
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label">
                Choose file…
              </span>
            </span>
            <span class="file-name">
              {{selectedFile.name}}
            </span>
          </label>
          <div>
            <button class="button is-text is-small" @click="onUpload" v-if="selectedFile.name">Refresh</button>
            &nbsp; &nbsp; <button class="button is-text is-small" @click="deleteImage(index)" v-if="myimage">Delete</button>
          </div>

        </div>
      </div>
    </div>

</section>
</template>

<script>

const uploadOptions = {
  /* headers: {
    'Content-Type': file.type, //'Content-Type': 'multipart/form-data'
  }, */
  onUploadProgress: (progressEvent) => {
    const { loaded, total } = progressEvent;
    console.log("uploadProgress:", loaded / total);
  },
};

import Api from '@/config/Api'

  export default {
    /*
      Defines the data used by the component
    */
    props: ['playId', 'item', 'imageKey', 'index', 'type'],
    /* watch: { 
      item: function(newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal);
        this.myimage = `/${playId}/mainimage.jpg` + '?unique=' + Math.random();
      }
    }, */
    data(){
      return {
        selectedFile: { name: null },
        myimage: {},
      }
    },
    /* computed: {
      playId() {
        return playId || this.playId;
      },
    }, */

    /*
      Defines the method used by the component
    */
    created() {
      /* console.log("imageKey = ",this.imageKey);
      console.log("index = ",this.index); */
      this.myimage = this.item[this.imageKey];
    },
    methods: {
      onFileChanged (event) {
        this.selectedFile = event.target.files[0];
        this.onUpload();
      },
      onUpload() {
        const formData = new FormData();
        formData.append('myfile', this.selectedFile, this.playId + "_" + `${this.imageKey}${this.index}.jpg`); //this.selectedFile.name);
        console.log("Uploading image...");
        console.log("  selectedFile:",this.selectedFile);
        console.log("  _id:",this.playId);

        //Api().post(`/api/${this.type}/${this.playId}/upload${this.imageKey}?index=${this.index}`, formData, uploadOptions)
        Api().post(`/api/${this.type}/${this.playId}/uploadimage?index=${this.index}`, formData, uploadOptions)
        .then(response => {
          console.log("response.data",response.data);
          var origfilename = response.data.originalname;
          var filename = response.data.filename;
          //var imagepath = response.data.path;
          console.log("successfully uploaded file: '" + origfilename + "' as '" + filename + "'");
          
          this.myimage = `/${this.playId}/${this.imageKey}${this.index}.jpg` + '?unique=' + Math.random(); //need to add random # to get Chrome to update (i.e. to prevent Chrome from caching the image)
          this.$nextTick(() => {
            this.myimage = `/${this.playId}/${this.imageKey}${this.index}.jpg` + '?unique=' + Math.random(); //need to add random # to get Chrome to update (i.e. to prevent Chrome from caching the image)
            console.log("myimage:",this.myimage);
            this.item[this.imageKey] = this.myimage;
            /* if (this.imageKey == 'photo') {
              this.item.url = this.myimage;
              delete this.item[this.imageKey];
            } */

          })

          /* var id = this.playId;
          setTimeout(function(){ 
            var mypath = `/${id}/mainimage.jpg` + '?unique=' + Math.random();
            console.log("mainimage2:",mypath);
            this.mainimage = mypath; //need to add random # to get Chrome to            
          }, 3000); */


          //this.item.mainimage = this.mainimage; //`/api/${this.type}/${this.playId}/uploadmainimage`;
        })
        .catch((error) => {
          console.log("errorrrr:",error);
          console.log("errorrrr.response:",error.response);
          console.log("errorrrr.response.data:",error.response.data);
          const message = error.response.data; //.message;
          this.$swal('Oh oo!', `${message}`, 'error');
        });
      },
      /*
        Removes a select file the user has uploaded
      */
      /* removeFile( key ){
        this.files.splice( key, 1 );
      }, */
      async deleteImage(imageIndex) {            
          var imagepath = `/${this.playId}/${this.imageKey}${this.index}.jpg`
          console.log('file:',imagepath);
          console.log("\n\n");
          
          Api().delete(`/api/${this.type}/${this.playId}/image`, {
            headers: {
                imagepath: imagepath
            }
          }).then(response => {
            //this.$swal('Deleted image', '', 'success');
            console.log('Deleted image');

          })
          .catch((error) => {
            var message;
            if (error) message = error;
            if (error.response) message = error.response;
            if (error.response.data) message = error.response.data;
            if (error.response.data.code) message = "Error code: " + error.response.data.code;
            if (error.response.data.message) message = error.response.data.message;
            console.log("errorrrr:",message);
            console.log(JSON.stringify(error.response.data, null, 4)); //Print object in full

            this.$swal('Oh oo!', `${message}`, 'error');
          });

          this.myimage = null;
          //this.items.splice( imageIndex, 1 );
          //this.item[this.imageKey] = null;
          delete this.item[this.imageKey]; //this.item[this.imageKey] = null;
      },
    }
  }
</script>

<style scoped>
  span.remove-file{
    color: red;
    cursor: pointer;
    /*float: right;*/
  }
</style>


// WEBPACK FOOTER //
// src/components/FileUpload.vue